import { TFunction } from 'i18next';
import { SupplierComplianceCoverageStatus } from '@texas/api/endpoints/variantsApi';
import { ensureEnumKey } from '@texas/utils/helpers/enumHelpers';

export function complianceCoverageStatusLabel(
  status: SupplierComplianceCoverageStatus,
  t: TFunction,
) {
  const key = ensureEnumKey(
    SupplierComplianceCoverageStatus,
    status,
  ) as unknown as keyof typeof SupplierComplianceCoverageStatus;
  return t(`supplierComplianceCoverage.status.${key}`);
}
